"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var store_component_1 = __importDefault(require("@hikakaku/shared/components/estimate_form/common/store_component"));
var big_photo_1 = __importDefault(require("@hikakaku/shared/components/estimate_form/common/input/dropzone_input/big_photo"));
var PhotosInput = (0, mobx_react_1.observer)(function (_a) {
    var store = _a.store;
    return (react_1.default.createElement("div", { className: "estimateForm-Photos" }, store.dropzoneStores.map(function (dropzone, idx) { return (react_1.default.createElement(store_component_1.default, { key: idx, store: dropzone },
        react_1.default.createElement(big_photo_1.default, { thumbnail: dropzone.thumbnail, withDeleteButton: Boolean(dropzone.value), resetValue: dropzone.resetValue }))); })));
});
exports.default = PhotosInput;
